"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebtRiskBanner = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var copy_1 = require("../../../../copy");
var DebtRiskBanner = function (_a) {
    var directDebitAmount = _a.directDebitAmount, isVariable = _a.isVariable, endOfContract = _a.endOfContract;
    var WarningNotification = (0, core_1.useComponents)().WarningNotification;
    var _b = (0, core_1.useCopy)(copy_1.defaultOptions), Copy = _b.Copy, copy = _b.copy;
    var contractTypeMessage = isVariable
        ? copy('changeDirectDebitTwelveMonthsBillingPeriod')
        : copy('changeDirectDebitContract');
    var formattedDate = (0, date_fns_1.format)(endOfContract, 'd MMMM');
    return (react_1.default.createElement(WarningNotification, { id: "debt-risk-banner", "data-testid": "debt-risk-banner" },
        react_1.default.createElement(Copy, { copyKey: "changeDirectDebitRiskBannerPayments", props: {
                directDebitAmount: directDebitAmount,
            }, values: { contractTypeMessage: contractTypeMessage, formattedDate: formattedDate } }),
        react_1.default.createElement(Copy, { copyKey: "changeDirectDebitRiskBannerAdjustPayments" })));
};
exports.DebtRiskBanner = DebtRiskBanner;
